import { useCallback, useEffect, useState } from "react";

// Desktop auto-update status from the Electron main process (see
// electron/updater.js). In the browser `updates` is undefined and this stays
// idle, so callers can use it unconditionally.
export const useAppUpdate = () => {
  const updates = window.electronAPI?.updates;
  const [status, setStatus] = useState({ state: "idle" });
  const [currentVersion, setCurrentVersion] = useState(null);

  useEffect(() => {
    if (!updates) return undefined;
    updates.getStatus().then(({ currentVersion: v, ...s }) => {
      setCurrentVersion(v);
      setStatus(s);
    });
    return updates.onStatus(setStatus);
  }, [updates]);

  const check = useCallback(() => updates?.check(), [updates]);
  const install = useCallback(() => updates?.install(), [updates]);

  return { available: !!updates, status, currentVersion, check, install };
};
